<template>
  <section
    id="target"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-md text-center">
      <h2 class="co-heading-2">
        こんな方におすすめ
      </h2>
      <div class="mb-5 flex flex-col gap-5 md:mb-14 md:flex-row md:gap-14">
        <div class="relative">
          <div class="te-target-eyecatch co-display-10 absolute z-10 inline-block p-3 font-bold leading-tight text-co-primary-400 md:p-4">
            働き方を変えたい
          </div>
          <div class="te-target-message co-display-8 absolute bottom-0 z-10 w-full p-3 text-center font-bold leading-normal text-co-gray-50">
            副業やフリーランスを目指したい
          </div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Target/target-1.webp"
            width="480"
            height="270"
            class="relative w-full"
            loading="lazy"
          >
        </div>
        <div class="relative">
          <div class="te-target-eyecatch co-display-10 absolute z-10 inline-block p-3 font-bold leading-tight text-co-primary-400 md:p-4">
            転職したい
          </div>
          <div class="te-target-message co-display-8 absolute bottom-0 z-10 w-full p-3 text-center font-bold leading-normal text-co-gray-50">
            未経験でもIT企業に転職したい
          </div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Target/target-2.webp"
            width="480"
            height="270"
            class="relative w-full"
            loading="lazy"
          >
        </div>
      </div>
      <div class="mb-8 flex flex-col gap-5 md:mb-14 md:flex-row md:gap-14">
        <div class="relative">
          <div class="te-target-eyecatch absolute z-10 inline-block p-3 font-bold leading-tight text-co-primary-400 md:p-4">
            費用を抑えたい
          </div>
          <div class="te-target-message absolute bottom-0 z-10 w-full p-3 text-center font-bold leading-normal text-co-gray-50">
            初期費用を減らして受講したい
          </div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Target/target-3.webp"
            width="480"
            height="270"
            class="relative w-full"
            loading="lazy"
          >
        </div>
        <div class="relative">
          <div class="te-target-eyecatch co-display-10 absolute z-10 inline-block p-3 font-bold leading-tight text-co-primary-400 md:p-4">
            スキルを学びたい
          </div>
          <div class="te-target-message co-display-8 absolute bottom-0 z-10 w-full p-3 text-center font-bold leading-normal text-co-gray-50">
            今を変えたいからITスキルを学びたい
          </div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Target/target-4.webp"
            width="480"
            height="270"
            class="relative w-full"
            loading="lazy"
          >
        </div>
      </div>
      <h3 class="te-target-cta-title mb-4 text-center font-bold leading-normal">
        あなたのご要望をお聞かせください<br>ヒアリングしたもとに、<br class="sm:hidden">最適な学習プランをご提案します
      </h3>
      <a
        href="/counseling/htmlcss-schedule"
        class="bot_open co-btn-counseling rounded-full"
      >
        まずは相談してみる
        <i
          class="fa fa-angle-right ml-2"
          aria-hidden="true"
        />
      </a>
    </div>
  </section>
</template>

<style scoped>
.te-target-eyecatch {
  top: 1rem;
  left: 1rem;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
}

.te-target-message {
  font-size: 1.125rem;
  background: linear-gradient(270deg, rgba(60, 170, 235, 0.90) 0%, rgba(70, 215, 203, 0.90) 100%);
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

.te-target-cta-title {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
}
</style>
